import React, { memo, ReactNode, useMemo } from 'react'
import { Modal, Typography } from '@mui/material'
import tw from 'twin.macro'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { colors } from 'src/theme'

interface Props {
  children?: ReactNode
  title: string
  isOpen?: boolean
  onClose(): void
}

const InviteMCModalComponent = ({ title, children, isOpen, onClose }: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur`}
      data-testid="mc-onboarding-invite-mc-modal"
    >
      <div css={tw`bg-white rounded-lg max-w-[528px]`}>
        <ModalHeader
          title={title}
          onClose={onClose}
          closeButtonDataTestId="mc-onboarding-invite-mc-modal-close-btn"
        />
        <div css={tw`py-4 mx-4 border-0 border-b border-solid border-[#EDEDED]`}>
          <Typography css={tw`mb-1`} variant="h4">
            Invite via email
          </Typography>
          <Typography variant="body2" color={colors.SHADES_GREY_400}>
            Enter the master contractor's basic info — the invite will be sent when you click 'Send
            Invite'.
          </Typography>
        </div>

        {children}
      </div>
    </Modal>
  )
}

export const InviteMCModal = memo(InviteMCModalComponent)
